import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const UPDATE_DEVICE_CONFIDENCE_SCHEMA = z.object({
  scrubberConfigId: z.string(),
  min_female_confidence: z.number(),
  min_male_confidence: z.number(),
  gender_body_conf: z.number(),
});

export type UpdateDeviceConfidenceParams = z.infer<typeof UPDATE_DEVICE_CONFIDENCE_SCHEMA>;

const UPDATE_DEVICE_CONFIDENCE_RESPONSE_SCHEMA = z.string();

/**@deprecated */
export const updateDeviceConfidencePromise = async (params: UpdateDeviceConfidenceParams) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    const validateParams = UPDATE_DEVICE_CONFIDENCE_SCHEMA.safeParse(params);

    if (!validateParams.success) {
      console.error(validateParams.error);
      return false;
    }

    const response = await ky
      .patch(`${ENV.API_URL}/api/update_device_confidence/${params.scrubberConfigId}/`, {
        headers,
        body: JSON.stringify({
          min_female_confidence: params.min_female_confidence,
          min_male_confidence: params.min_male_confidence,
          gender_body_conf: params.gender_body_conf,
        }),
      })
      .json();

    const res = UPDATE_DEVICE_CONFIDENCE_RESPONSE_SCHEMA.safeParse(response);

    if (!res.success) {
      return false;
    }

    return res.data?.toLowerCase()?.includes('success');
  } catch (error) {
    console.error('Error updating device confidence:', error);
    return false;
  }
};
